import type {
  InboundAttachment,
  InboundEmlAttachment,
} from './attachment-list-types';

/**
 * A locale code in the format of xx-XX (e.g. en-US, en-CA, es-MX, etc.)
 */
type LocaleCode = string;

export function generateAttachmentList(attachments: InboundAttachment[]): {
  emlAttachment: InboundEmlAttachment | null;
  emlTranslations: Record<LocaleCode, InboundEmlAttachment>;
  filteredAttachments: InboundAttachment[];
} {
  const uniqueAttachmentUrls = new Set<string>();
  const filtered: InboundAttachment[] = [];
  let eml: InboundEmlAttachment | null = null;
  let localeToTranslatedEmlMap: Record<string, InboundEmlAttachment> = {};

  for (const attachment of attachments) {
    if (attachment.type === 'EML') {
      // Our assumption here is that we only have one "original" EML, but can have multiple translated EMLs for
      // different locales (en-US, es-MX, zh-CN, etc.).
      // We also have the assumption that the original highlights file will always be "original-highlights.eml" and
      // any translated EMLs will be in the format of "translated-{LOCALE_CODE_HERE}-highlights.eml

      const translatedEmlMatch = attachment.url.match(
        /translated-([a-z]{2}-[A-Z]{2})-highlights\.eml/,
      );

      if (translatedEmlMatch) {
        localeToTranslatedEmlMap[translatedEmlMatch[1]] = attachment;
      } else {
        eml = attachment;
      }
    } else {
      const uniqueAttachmentKey = `${attachment.type}+${attachment.url}`;

      if (!uniqueAttachmentUrls.has(uniqueAttachmentKey)) {
        filtered.push(attachment);
        uniqueAttachmentUrls.add(uniqueAttachmentKey);
      }
    }
  }

  return {
    emlAttachment: eml,
    emlTranslations: localeToTranslatedEmlMap,
    filteredAttachments: filtered,
  };
}
